import { CKEditor } from '@ckeditor/ckeditor5-react'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import { useEffect } from 'react'
import Button from '@mui/material/Button'
import { Box } from '@mui/system'
import { useRef } from 'react'
const CkEditor = ({ initialData, setEditorData, addFunction }) => {
    const editor = useRef(null)

    useEffect(() => {
        if (editor.current) {
            editor.current.editor.ui
                .getEditableElement()
                .parentElement.insertBefore(
                    editor.current.editor.ui.view.toolbar.element,
                    editor.current.editor.ui.getEditableElement()
                )
        }
    }, [])
    return (
        <div
            style={{
                marginBottom: '40px',
            }}
        >
            <div className="App">
                <CKEditor
                    onReady={(editor) => {
                        console.log('Editor is ready to use!', editor)
                        editor.ui
                            .getEditableElement()
                            .parentElement.insertBefore(
                                editor.ui.view.toolbar.element,
                                editor.ui.getEditableElement()
                            )
                    }}
                    onError={({ willEditorRestart }) => {
                        if (willEditorRestart && editor.current) {
                            editor.current.editor.ui.view.toolbar.element.remove()
                        }
                    }}
                    onChange={(event, editor) => {
                        const data = editor.getData()
                        setEditorData(data)
                    }}
                    editor={DecoupledEditor}
                    data={initialData}
                    ref={editor}
                />
            </div>
            <Button
                variant="contained"
                sx={{ marginRight: 2 }}
                onClick={addFunction}
                style={{
                    position: 'absolute',
                    right: '10px',
                    marginTop: '10px',
                }}
            >
                Submit
            </Button>
        </div>
    )
}

export default CkEditor

{
    /* <CKEditor
editor={ClassicEditor}
data={initialData}
onReady={(editor) => {
    // You can store the "editor" and use when it is needed.
    // console.log('Editor is ready to use!', editor)
}}
onChange={(event, editor) => {
    const data = editor.getData()
    setEditorData(data)
    // console.log(data)
}}
onBlur={(event, editor) => {
    // console.log('Blur.', editor)
}}
onFocus={(event, editor) => {
    // console.log('Focus.', editor)
}}
/> */
}
